import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useInstructorWelcomeModal() {
    const [searchParams, setSearchParams] = useSearchParams();

    const isOpen = searchParams.get("instructor-welcome") === "true";

    const openModal = useCallback(() => {
        setSearchParams((params) => {
            params.set("instructor-welcome", "true");
            return params;
        });
    }, [setSearchParams]);

    const closeModal = useCallback(() => {
        setSearchParams((params) => {
            params.delete("instructor-welcome");
            return params;
        });
    }, [setSearchParams]);

    return { isOpen, openModal, closeModal };
}
